import { useResidentModalsApi } from '@/components/modals/ResidentModals'
import { selectStorageSpaceData } from '@/features/domain/order'
import { useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'

export function useAlertUserNotAbleToCreateOrders() {
  const unableToCreateRecurrenceOrderPromiseRef = useRef<{
    resolve: () => void
    reject: (reason?: any) => void
  }>()

  const { percentage: storagePercentage } = useSelector(selectStorageSpaceData)
  const {
    unableToCreateRecurrentOrders: { show: showUnableToCreateRecurrenceOrderModal },
  } = useResidentModalsApi()

  const alertUserUnableToCreateRecurrenceOrder = useCallback(() => {
    return new Promise<void>((resolve, reject) => {
      unableToCreateRecurrenceOrderPromiseRef.current = { resolve, reject }
      showUnableToCreateRecurrenceOrderModal({
        mode: 'create',
        onManageStorage: () => {
          if (unableToCreateRecurrenceOrderPromiseRef.current) {
            unableToCreateRecurrenceOrderPromiseRef.current.resolve()
            unableToCreateRecurrenceOrderPromiseRef.current = undefined
          }
        },
        onGoBackToEdit: () => {
          if (unableToCreateRecurrenceOrderPromiseRef.current) {
            unableToCreateRecurrenceOrderPromiseRef.current.reject()
            unableToCreateRecurrenceOrderPromiseRef.current = undefined
          }
        },
        storageSaturationPercent: storagePercentage,
      })
    })
  }, [showUnableToCreateRecurrenceOrderModal])

  return {
    unableToCreateRecurrenceOrderPromiseRef,
    alertUserUnableToCreateRecurrenceOrder,
  }
}
